
export function useQuerystring ()
{
    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => typeof prop === "string" ? searchParams.get(prop) : "",
    });


    return params;
}
